module.exports = {
  label: 'История файлов',
  Details: 'Свойства',
  view: 'Просмотр файла',
  PlsInput: 'Введите',
  Query: 'Поиск',
  fileName: 'Имя файла',
  fileVersion: 'Версия',
  jobType: 'Тип файла',
  fileType: 'Формат файла',
  fileSize: 'Размер файла',
  createdBy: 'Создатель',
  createdDate: 'Дата создания',
  tagName: 'Имя свойства',
  tagValue: 'Значение свойства',
  Tips: 'Подсказка',
  DownloadFile: 'Сохранить файл?',
  Succeed: 'Загрузка успешна',
  Failed: 'Ошибка загрузки',
  noFile: 'Нет истории.',
  Refresh: 'Обновить',
  Upload: 'Загрузить',
  Delete: 'Удалить',
  BatchDownload: 'Массовая загрузка',
  SendEmail: 'Отправить письмо',
  TransferAllToFileHistory: 'Перенести все в историю файлов',
  ingotUpload: 'Загрузка ingot',
  ingotLog: 'Журнал ingot',
  preview: 'Предпросмотр',
  synchronization: 'Синхронизация',
  cancelSynchronization: 'Отменить синхронизацию',
  synchronizationState: 'Статус синхронизации',
  operation: 'Действие',
  fileDownload: 'Скачать файл',
  ExternalFileType: 'Тип внешнего файла',
  LastSyncTime: 'Время последней синхронизации',
  DisplayTicketFile: 'Показать файлы чеков',
  SendDestinationPortAgent: 'Отправить агенту порта назначения',
  SentDestinationPortAgent: 'Отправлено агенту порта назначения',
  ResetOneClickSend: 'Сбросить отправку',
  FileCreator: 'Создатель файла',
  FileCreationDate: 'Дата создания файла',
  HasDeleted: 'Удалить?',
  SendSetOfProxyOrders: 'Отправить агенту комплекта документов',
  ProxyName: 'Название агента'
}
